module.exports = __webpack_public_path__ + "static/media/ESNcard.cabec04a.jpg";